<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="15.425" height="15.35" viewBox="0 0 15.425 15.35" focusable="false" aria-hidden="true">
        <g transform="translate(-17.445 -16.191)">
            <g transform="translate(25.195 17.605)">
                <line x2="6.261" y2="6.261" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"/>
                <line y1="6.261" x2="6.261" transform="translate(0 6.261)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"/>
            </g>
            <g data-name="Group 66287" transform="translate(18.859 17.605)">
                <line x2="6.261" y2="6.261" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"/>
                <line y1="6.261" x2="6.261" transform="translate(0 6.261)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"/>
            </g>
        </g>
    </svg>
</template>